/**
 * Типы ошибок
 */
export enum ErrorType {
  Balance = "balance",
  Limit = "limit",
  Unknown = "unknown",
}
